import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene los resultados de EPSt por secciones a partir del ID del usuario o certificación.
 * @param {string|number} id - ID del usuario o certificación.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta con resultados por sección.
 */
export const fetchEpstResultBySections = async (id, token) => {
	const response = await certifications.get(`/epst/results/sections/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene los resultados de EPSt por ID de certificación.
 * @param {string|number} id - ID de la certificación.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Resultado de la certificación.
 */
export const fetchEpstResultByCertificationId = async (id, token) => {
	const response = await certifications.get(`/epst/results/certification/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea resultados para una certificación EPSt.
 * @param {Object} data - Datos de resultados a guardar.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const createEpstResults = async (data, token) => {
	const response = await certifications.post(`/epst/results`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const createEpstResultCertification = async (data, token) => {
	const response = await certifications.post(`/epst/result/certifications`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const fetchEpstResultFinished = async (token) => {
	const response = await certifications.get(`/epst/results/finished`, {
		headers: getHeaders(token)
	});
	return response.data;
};

export const fetchEpstScoreSheetByCertification = async (certificationId, sectionId = null, token) => {
	const response = await certifications.get(`/epst/score/sheet/certification/${certificationId}`, {
		headers: getHeaders(token),
		params: sectionId ? { section_id: sectionId } : {}
	});
	return response.data;
};

//epst/results/<int:certification_id>

export const updateEpstScoreCertificationSection = async (certificationId, data, token) => {
	const response = await certifications.put(`/epst/results/${certificationId}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const fetchEpstResultsByCertificationId = async (certificationId, token) => {
	const response = await certifications.get(`/epst/result/certification/${certificationId}`, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const fetchEpstResultsExport = async (token) => {
	const response = await certifications.get(`/epst/results/export`, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const fetchEpstScoreStatisticsByCertification = async (certificationId, candidate_type = null, token) => {
	const response = await certifications.get(`/epst/score/sheet/statistics/${certificationId}`, {
		headers: getHeaders(token),
		params: candidate_type ? { candidate_type: candidate_type } : {}
	});
	return response.data;
};